import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="disclosure"
export default class extends Controller {
  static targets = ["content", "button"];
  static values = {
    hasSelected: { type: Boolean, default: false }
  }
  
  connect() {
    // Check if there's a selection count span in the header
    const header = this.element.querySelector("h3");
    const hasSelected = header?.querySelector("span") !== null;
    
    // Initialize content visibility - show if there are selected items
    this.contentTargets.forEach((content) => {
      if (hasSelected) {
        // If items are selected, keep the filter open
        content.hidden = false;
        const icon = this.element.querySelector("svg");
        if (icon) icon.style.transform = "rotate(180deg)";
      } else {
        content.hidden = true;
      }
    });
  }

  toggle(event) {
    // Access the content target directly
    const content = this.contentTarget;
    
    // Toggle visibility
    content.hidden = !content.hidden;

    // Rotate the icon
    const icon = event.currentTarget.querySelector("svg");
    if (icon) {
      icon.style.transform = content.hidden ? "rotate(0deg)" : "rotate(180deg)";
    }
  }
}
